/**
 * Preview card for a dance in the list view
 */

import { Link } from 'react-router-dom';
import type { Dance } from '../api/danceApi';

interface DanceCardProps {
  dance: Dance;
}

export function DanceCard({ dance }: DanceCardProps) {
  return (
    <Link
      to={`/dances/${dance.danceId}`}
      style={{ textDecoration: 'none', color: 'inherit' }}
      onClick={() => {
        // Track with Datadog RUM
        if (window.DD_RUM) {
          window.DD_RUM.addAction('dance_card_clicked', {
            danceId: dance.danceId,
            source: dance.source,
            title: dance.title
          });
        }
      }}
    >
      <div className="card card-clickable" style={{ backgroundColor: 'white' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: 'var(--spacing-sm)' }}>
          <h3 style={{ margin: 0, fontSize: '1.25rem' }}>{dance.title}</h3>
          <span className={`badge ${dance.source === 'AI' ? 'badge-ai' : 'badge-manual'}`}>
            {dance.source}
          </span>
        </div>

        {dance.choreographer && (
          <p style={{ margin: 'var(--spacing-sm) 0', color: 'var(--color-text-secondary)' }}>
            by {dance.choreographer}
          </p>
        )}

        <p style={{ margin: 'var(--spacing-sm) 0', fontSize: '0.9rem', color: 'var(--color-text-light)' }}>
          {dance.formation}
        </p>

        <div style={{ marginTop: 'var(--spacing-sm)', display: 'flex', gap: 'var(--spacing-sm)', flexWrap: 'wrap' }}>
          {dance.difficulty && (
            <span className="badge badge-difficulty">{dance.difficulty}</span>
          )}
          {dance.style && (
            <span className="badge badge-style">{dance.style}</span>
          )}
          {dance.energyLevel && (
            <span style={{
              padding: '0.15rem 0.5rem',
              borderRadius: '12px',
              fontSize: '0.75rem',
              fontWeight: '600',
              backgroundColor: dance.energyLevel === 'high' ? '#dc3545' : dance.energyLevel === 'medium' ? '#fd7e14' : '#28a745',
              color: 'white'
            }}>
              {dance.energyLevel}
            </span>
          )}
          {dance.programRole && (
            <span style={{
              padding: '0.15rem 0.5rem',
              borderRadius: '12px',
              fontSize: '0.75rem',
              fontWeight: '600',
              backgroundColor: '#6f42c1',
              color: 'white'
            }}>
              {dance.programRole}
            </span>
          )}
        </div>

        {dance.tags && dance.tags.length > 0 && (
          <div style={{ marginTop: 'var(--spacing-sm)' }}>
            {dance.tags.slice(0, 3).map(tag => (
              <span key={tag} className="tag-chip">{tag}</span>
            ))}
            {dance.tags.length > 3 && (
              <span className="tag-chip" style={{ fontStyle: 'italic' }}>+{dance.tags.length - 3} more</span>
            )}
          </div>
        )}

        {dance.moves && dance.moves.length > 0 && (
          <div style={{ marginTop: 'var(--spacing-sm)' }}>
            {dance.moves.slice(0, 4).map(move => (
              <span key={move} style={{
                display: 'inline-block',
                margin: '2px',
                padding: '0.15rem 0.5rem',
                backgroundColor: '#d4edda',
                color: '#155724',
                borderRadius: '12px',
                fontSize: '0.75rem',
                border: '1px solid #c3e6cb'
              }}>
                {move}
              </span>
            ))}
            {dance.moves.length > 4 && (
              <span style={{
                display: 'inline-block',
                margin: '2px',
                padding: '0.15rem 0.5rem',
                backgroundColor: '#d4edda',
                color: '#155724',
                borderRadius: '12px',
                fontSize: '0.75rem',
                fontStyle: 'italic',
                border: '1px solid #c3e6cb'
              }}>
                +{dance.moves.length - 4} more
              </span>
            )}
          </div>
        )}
      </div>
    </Link>
  );
}
